import { Module } from 'vuex';
import { RootState } from '@/plugins/store';
import { EstimateRequestState, state } from '@/modules/Estimate/store/state';
import { mutations } from '@/modules/Estimate/store/mutations';
import { actions } from '@/modules/Estimate/store/actions';
import { getters } from '@/modules/Estimate/store/getters';

const module: Module<EstimateRequestState, RootState> = {
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type {EstimateRequestState};
